import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CountriesMap, Country, EArticleAlias, ELegalsViews, IArticle } from '../types';
import { ILegalsCountriesUpdatePayload, ILegalsRequestPayload } from './types';

export interface IAppState {
  // i18next is started
  ready: boolean;
  articles: IArticle[];
  error: string;
  view: ELegalsViews;
  countries: CountriesMap;
  mostCommon: Country[];
}

export const initialState: IAppState = {
  ready: false,
  articles: [],
  error: '',
  view: ELegalsViews.SelectCountry,
  countries: {},
  mostCommon: [],
};

export const statePropName = 'legals';

const legalsSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    legalsInit(state) {
      state.ready = false;
    },
    legalsUpdateCountries: {
      reducer: (state, action: PayloadAction<ILegalsCountriesUpdatePayload>) => {
        state.countries = action.payload.countries;
        state.mostCommon = action.payload.mostCommon;
        state.ready = true;
      },
      prepare: (countries: CountriesMap, mostCommon: Country[]) => ({
        payload: { countries, mostCommon },
      }),
    },
    legalsRequest: {
      reducer: (state, action: PayloadAction<ILegalsRequestPayload>) => {
        state.ready = false;
        state.articles = [];
      },
      prepare: (articleAlias: EArticleAlias, country: string) => ({
        payload: { articleAlias, country },
      }),
    },
    legalsLoaded(state, action: PayloadAction<IArticle[]>) {
      state.articles = action.payload;
      state.view = ELegalsViews.Articles;
      state.ready = true;
    },
    legalsFailed(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.ready = true;
    },
    legalsReset(state) {
      state.ready = false;
      state.articles = [];
      state.error = '';
      state.view = ELegalsViews.SelectCountry;
      state.countries = {};
      state.mostCommon = [];
    },
  },
});

export const LegalsActions = legalsSlice.actions;
export default legalsSlice.reducer;
